import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProtectedRoute from './ProtectedRoute';

/**
 * SubUserRoute — wraps ProtectedRoute and additionally blocks non-SUB_USER roles.
 * Admins who try to access /trade/* get redirected to /dashboard.
 */
export default function SubUserRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;

  // Admins have their own dashboard — don't let them into the sub-user portal
  if (user && (user.role === 'admin' || user.role === 'SUPER_ADMIN')) {
    return <Navigate to="/dashboard" replace />;
  }

  return <ProtectedRoute>{children}</ProtectedRoute>;
}
